import { generateRandomId } from "./generateRandomId";

export const createDish = () => ({
    id: generateRandomId(),
    name: '',
    description: '',
    imageUrl: '',
    options: []
})
export const generateEmptyOption = () => ({
    title: '',
    values: ['']
});
export const getDishId = ({id}) => id;

export const getDefaultDishOptions = (options = []) => options.map(
    ({id, values}) => ({id: id, value: values[0]})
);

const isOptionComplete = ({title, values}) => {
    const areValuesValid = !values.find((value) => !value);
    return !!title && areValuesValid;
}

export const isDishComplete = ({
                                   name,
                                   description,
                                   options = []
                               }) => {
    const areFieldsFilled = name && description;
    const areOptionsValid = !options.find((option) => !isOptionComplete(option));
    return !!areFieldsFilled && areOptionsValid;
};
